import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { isEqual } from "lodash";
import { FaPlus } from "react-icons/fa";
import { Box } from "@chakra-ui/react";
import { DURATION_PIXEL_RATIO } from "../../_components/styled/variable";
import Rail from "./Rail";
import ArtboardBlock from "./ArtboardBlock";
import { StyledAddBlock } from "./styled";

const VideoRail = React.memo(
  ({
    duration,
    timescale,
    pagesData,
    activePage,
    switchArtboardOnClick,
    seek,
    updateArtboardDuration,
    addArtboard,
    openAdvancedSettingsArtboard,
    extraBufferSeconds,
    onResizeArtboardBlock,
    canvasRef,
  }) => {
    const [pagesDataWithTimeAndWidth, setPagesDataWithTimeAndWidth] = useState(
      []
    );
    const buildData = (data) => {
      let previousEndTime = 0;

      return data.map((p) => {
        p.startTime = previousEndTime;
        previousEndTime = p.endTime = p.startTime + p.duration;
        p.offset = p.startTime * DURATION_PIXEL_RATIO * timescale;
        p.oldOffset = p.offset;
        p.width = p.duration * DURATION_PIXEL_RATIO * timescale;
        return p;
      });
    };

    useEffect(() => {
      if (pagesData && pagesData.length > 0) {
        const n = buildData(pagesData);
        setPagesDataWithTimeAndWidth(n);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pagesData, timescale]);

    return (
      <Rail
        id="video-rail"
        height="100px"
        width={
          duration * DURATION_PIXEL_RATIO * timescale +
          extraBufferSeconds * DURATION_PIXEL_RATIO * timescale
        }
      >
        {pagesDataWithTimeAndWidth.map((page, idx) => {
          // const start = idx > 0 ? pagesData[idx - 1].endTime : 0;
          // const end = start + page.duration;
          return (
            <ArtboardBlock
              canvasRef={canvasRef}
              offset={page.offset}
              width={page.width}
              index={idx}
              parentId="#video-rail"
              page={page}
              key={page.id}
              order={idx}
              // start={start}
              // end={end}
              isActive={activePage.id === page.id}
              id={page.id}
              scale={timescale}
              onClick={() => {
                switchArtboardOnClick(page.id, idx);
                seek(page.startTime);
              }}
              onClickAnimate={() => openAdvancedSettingsArtboard(page.id, idx)}
              onResize={(e, d, ref, delta, pos) => {
                setPagesDataWithTimeAndWidth(
                  pagesDataWithTimeAndWidth.map((p, pIdx) => {
                    if (pIdx === idx) {
                      p.width = ref.offsetWidth;
                    } else if (pIdx > idx) {
                      p.offset = p.oldOffset + delta.width;
                    }
                    return p;
                  })
                );
                onResizeArtboardBlock(idx, e, d, ref, delta, pos);
              }}
              onResizeStop={(e, d, ref, delta, pos) => {
                setPagesDataWithTimeAndWidth(
                  pagesDataWithTimeAndWidth.map((p, pIdx) => {
                    if (pIdx === idx) {
                      p.width = ref.offsetWidth;
                    } else if (pIdx > idx) {
                      p.offset = p.oldOffset + delta.width;
                      p.oldOffset = p.offset;
                    }
                    return p;
                  })
                );
                const roundedDuration = Number(
                  (
                    ref.offsetWidth /
                    (DURATION_PIXEL_RATIO * timescale)
                  ).toFixed(1)
                );
                updateArtboardDuration(idx, roundedDuration);
                onResizeArtboardBlock(idx, e, d, ref, delta, pos);
              }}
            />
          );
        })}
        <Box
          alignSelf="stretch"
          px={2}
          style={{
            width: `${DURATION_PIXEL_RATIO * timescale * 6}px`,
            transform: `translate(${
              pagesDataWithTimeAndWidth.length
                ? pagesDataWithTimeAndWidth[
                    pagesDataWithTimeAndWidth.length - 1
                  ].offset +
                  pagesDataWithTimeAndWidth[
                    pagesDataWithTimeAndWidth.length - 1
                  ].width
                : 0
            }px, 0)`,
          }}
        >
          <StyledAddBlock onClick={addArtboard}>
            <FaPlus />
          </StyledAddBlock>
        </Box>
      </Rail>
    );
  },
  (prevProps, nextProps) =>
    isEqual(prevProps.pagesData, nextProps.pagesData) &&
    isEqual(prevProps.activePage, nextProps.activePage) &&
    prevProps.timescale === nextProps.timescale &&
    prevProps.duration === nextProps.duration &&
    prevProps.extraBufferSeconds === nextProps.extraBufferSeconds
);

VideoRail.defaultProps = {
  extraBufferSeconds: 20,
};

VideoRail.propTypes = {
  duration: PropTypes.number,
  timescale: PropTypes.number,
  pagesData: PropTypes.array,
  activePage: PropTypes.object,
  switchArtboardOnClick: PropTypes.func,
  seek: PropTypes.func,
  updateArtboardDuration: PropTypes.func,
  addArtboard: PropTypes.func,
  openAdvancedSettingsArtboard: PropTypes.func,
  extraBufferSeconds: PropTypes.number,
  onResizeArtboardBlock: PropTypes.func,
};

export default VideoRail;
